/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationStates200,
  GetApiV1LocationStates401,
  GetApiV1LocationStates500,
  GetApiV1LocationStatesQueryResponse,
} from "../../types/locationStateController/GetApiV1LocationStates.ts";
import { stateViewModelSchema } from "../stateViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationStates200Schema = z.array(
  z.lazy(() => stateViewModelSchema),
) as unknown as ToZod<GetApiV1LocationStates200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationStates401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStates401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationStates500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStates500>;

export const getApiV1LocationStatesQueryResponseSchema = z.lazy(
  () => getApiV1LocationStates200Schema,
) as unknown as ToZod<GetApiV1LocationStatesQueryResponse>;
